import React from "react";

export default function LoadingComponent({ isOpen }) {
    if (!isOpen) return null; // Do not render if not open

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                <p className="mt-4 text-lg font-semibold">Loading...</p>
            </div>
        </div>
    );
}
